"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderCustomerSummary = void 0;
const React = require("react");
const react_1 = require("react");
const useElementDimension_1 = require("../../../../../hooks/useElementDimension");
const SalesOrderSummaryInfo_1 = require("./SalesOrderSummaryInfo");
const SalesOrderSummaryStatus_1 = require("./SalesOrderSummaryStatus");
const SalesOrderSummaryProgress_1 = require("./SalesOrderSummaryProgress");
const SalesOrderSummaryMap_1 = require("./SalesOrderSummaryMap");
const SalesOrderSummaryMobile_1 = require("./SalesOrderSummaryMobile");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "SalesOrderCustomerSummary");
const SalesOrderCustomerSummary = ({ salesOrder }) => {
    const [ref, { height, width }] = (0, useElementDimension_1.useElementDimension)();
    const visibleMap = (0, react_1.useMemo)(() => {
        const desktopMap = document.getElementById("desktopMap");
        if (!desktopMap) {
            return null;
        }
        const style = window.getComputedStyle(desktopMap);
        return style.display === "none" ? "mobile" : "desktop";
    }, [height, width]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: css(""), ref: ref },
            React.createElement("div", { className: css("container") },
                React.createElement(SalesOrderSummaryStatus_1.SalesOrderCustomerStatus, { salesOrder: salesOrder }),
                React.createElement(SalesOrderSummaryProgress_1.SalesOrderSummaryProgress, { salesOrder: salesOrder }),
                visibleMap === "desktop" ? (React.createElement(SalesOrderSummaryInfo_1.SalesOrderSummaryInfo, { salesOrder: salesOrder })) : (React.createElement(SalesOrderSummaryMobile_1.SalesOrderSummaryMobile, { visibleMap: visibleMap, salesOrder: salesOrder }))),
            React.createElement(SalesOrderSummaryMap_1.SalesOrderSummaryMap, { salesOrder: salesOrder, variant: "desktop", isVisible: visibleMap === "desktop" }))));
};
exports.SalesOrderCustomerSummary = SalesOrderCustomerSummary;
//# sourceMappingURL=index.js.map